/**
 * Function called on each property.
 *
 * @callback forOwnCallback
 * @param {*} key
 * @param {*} value
 */

/**
 * Iterates over own enumerable `obj` properties.
 *
 * @param {Object} obj
 * @param {forOwnCallback} cb
 * @return {Boolean}
 */
export const forOwn = (obj, cb) => {
  const keys = Object.keys(obj);

  for (let i = 0, max = keys.length; i < max; i++) {
    cb(keys[i], obj[keys[i]]);
  }
};
